<p-toast />
<app-container-manager-login>
  <form class="p-fluid" autocomplete="off" [formGroup]="form" (submit)="login()">
    <div class="p-field p-mb-3">
      <label for="usuario" class="p-mb-2 block">Usuário</label>
      <input id="usuario" type="email" pInputText placeholder="E-mail" formControlName="usuario" />
    </div>
    <div class="p-field p-mb-3">
      <label for="senha" class="p-mb-2 block">Senha</label>
      <p-password id="senha" formControlName="senha" placeholder="Senha" [toggleMask]="false" [feedback]="false"
        styleClass="w-full" inputStyleClass="w-full"></p-password>
    </div>

    <div class="p-field p-mb-3">
      <button pButton type="submit" [disabled]="form.invalid || loadding" [label]="loadding ? '' : 'Entrar'"
        class="p-button-primary w-full p-d-flex p-jc-center p-ai-center">
        <i class="pi pi-spin pi-spinner" *ngIf="loadding"></i>
      </button>
    </div>

    <div class="p-d-flex p-jc-between p-mb-3" *ngIf="enableRegistration || true">
      <a [routerLink]="['/', registrationRoute]" class="p-link auth-link" *ngIf="enableRegistration">
        Criar conta
      </a>
      <a [routerLink]="['/', resetPasswordRoute]" class="p-link auth-link">
        Esqueceu a senha?
      </a>
    </div>
  </form>
</app-container-manager-login>